var React = require('react');

function RemixUserStarFill (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M12 14v8H4a8 8 0 0 1 8-8zm6 7.5l-2.939 1.545.561-3.272-2.377-2.318 3.286-.478L18 14l1.47 2.977 3.285.478-2.377 2.318.56 3.272L18 21.5zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z","key":1})]);
}

RemixUserStarFill.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = RemixUserStarFill;

RemixUserStarFill.default = RemixUserStarFill;
